import React from 'react';
import { translate } from 'react-i18next';
import { Segment, Container, Card, Image, Label, Icon, Button } from 'semantic-ui-react';

import TimeRemainingLabel from 'modules/misc/TimeRemainingLabel.js';
import ChallengeUtils from 'utils/ChallengeUtils.js';
import Utils from 'utils/Utils.js';
import {colors, fontSizes, fonts} from 'style';

const style = {
    card: {
        ...fonts.body,
        lineHeight: '1.5',
        backgroundColor: colors.themeBlue,
        color: '#fff',
        width: '400px',
    },
    cropper: {
        width: '100%',
        overflow: 'hidden',
        borderRadius: 'inherit',
        border: 'none',
    },
    content: {
        paddingTop: '5px',
        paddingBottom: '5px',
    },
    image:{
        width: '100%',
        minHeight: '300px',
        backgroundSize:'cover',
        backgroundPositionY: 'center',
        backgroundPositionX: 'center',
        backgroundRepeat: 'no-repeat',
    },
    cardHeader: {
        color: '#fff',
        textAlign: 'center',
        fontSize: '0.95em',
    },
    meta: {
        paddingTop: '5px',
    },
    metaItem: {
        textAlign: 'center',
        fontWeight: 'light',
        fontSize: '0.9em',
        lineHeight: '1.2em',
    },
    pointsIcon: {
        color: colors.pointsYellow,
    },
    leaderboardIcon: {
        position: 'absolute', 
        right: '10px',
        top: '30px',
        color: '#fff',
        backgroundColor : colors.themeBlue,
        borderRadius: '50%',
        width: '50px',
        height: '50px',
        lineHeight: '45px',
        fontSize: '35px',
    },
    timeRemaining: {
        position: 'absolute',
        top: '-20px',
        left: '50%',
        marginLeft: '-125px',
        zIndex: '10',
    }
};

const TeamChallengeCard = ({t,
                            leaderboard,
                            onClickLeaderboard,
                            onClickLeaderboardIcon,
                            centered}) => (
    <Card key={leaderboard.id} style={style.card} onClick={()=>onClickLeaderboard(leaderboard)} centered={centered}>
        <div>{/*This affects style*/}</div>
        {(leaderboard.season && leaderboard.season.endsAt) &&
            <TimeRemainingLabel style={style.timeRemaining} endsAt={leaderboard.season.endsAt} />
        }
        <div style={style.cropper}>
            <div style={{...style.image, backgroundImage:Utils.url(leaderboard.banner.sourceUrl)}} alt="" />
            <Icon style={style.leaderboardIcon} className='icon-leaderboard' onClick={e=>{e.stopPropagation(); onClickLeaderboardIcon(leaderboard)}} />
            <Card.Content style={style.content}>
                <Card.Header style={style.cardHeader}>
                    {leaderboard.title}
                </Card.Header>
                {leaderboard.challenge &&
                <div style={style.meta}>
                    <div style={style.metaItem}>
                        {leaderboard.challenge.points} <Icon style={style.pointsIcon} className='icon-star' />
                    </div>
                    <div style={style.metaItem}>
                        {t('challenges:::'+ChallengeUtils.Types[leaderboard.challenge.type])}
                    </div>
                    {Boolean(leaderboard.challenge.duration>0) &&//Timed
                        <div style={style.metaItem}>
                            {ChallengeUtils.formatDuration(t, leaderboard.challenge.duration)}
                        </div>
                    }
                </div>
                }
            </Card.Content>
        </div>
        <div>{/*This affects style*/}</div>
    </Card>
);

export default translate(['teamchallenges', 'challenges'])(TeamChallengeCard);



// WEBPACK FOOTER //
// ./src/modules/teamchallenges/TeamChallengeCard.js